import React, { useEffect } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import { FormTemplate } from "../../../Components/Forms/InputTemplate";
import { FormProvider } from "react-hook-form";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
// import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";

import { useSearchParams } from "react-router-dom";
import { GetSingleJobListing } from "../../../../../utils/redux/HR/HRSlice";
import ApplicantForJobListing from "./ApplicantForJobListing";
import ApplicantSelected from "./ApplicantSelected";

const Tabs = ({type}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "job-details";

  const tabs = [
    { name: "Job Details", value: "job-details" },
    { name: "Applicants", value: "applicants" },
    { name: "Selected", value: "selected" },
  ];

  const handleTabClick = (value) => {
    setSearchParams({ tab: value, type: type }); // Update the `tab` query parameter
  };

  return (
    <div className="border-b border-gray-300">
      <div className="flex">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => handleTabClick(tab.value)}
            className={`px-6 py-2 text-sm font-medium transition-colors duration-200 border border-gray-300 ${
              currentTab === tab.value
                ? "border-t-2 border-l-2 border-r-2 border-green-300 bg-white text-black font-bold rounded-t-md"
                : "bg-gray-100 text-gray-500 hover:text-black rounded-t-md border border-transparent"
            }`}
          >
            {tab.name}
          </button>
        ))}
      </div>
    </div>
  );
};

function RecruitmentReviewGroup() {
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get("tab") || "job-details";

  const url = new URL(window.location.href);
  const type = new URLSearchParams(url.search).get("type");

  const { id } = useParams();
  const dispatch = useDispatch();

  const { get_singlejoblisting } = useSelector((state) => state?.hr);

  const acq = get_singlejoblisting?.responseObject;

  useEffect(() => {
    dispatch(GetSingleJobListing({ Id: id }));
  }, [dispatch, id]);

  const renderContent = () => {
    switch (currentTab) {
      case "job-details":
        return (
          <div>
            <FormProvider>
              <FormTemplate
                className={DashboardStyle.view_app_components}
                // handleSubmit={handleSubmit(submit)}
              >
                {/* Process Information Section */}
                <section
                  style={{
                    backgroundColor: "#F8FBF8",
                    border: "1px solid #D9E9DA",
                    borderRadius: "8px",
                  }}
                  className={DashboardStyle.form_section}
                >
                  <h4 className={DashboardStyle.form_section_title}>
                    Process <br /> Information
                  </h4>
                  <div className={DashboardStyle.labels_group}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(32.3%, 1fr))",
                        gap: "10px",
                      }}
                    >
                      <div>
                        <p>Process Type:</p>
                        <h4>Recruitment Process</h4>
                      </div>
                      <div>
                        <p>Date Initiated:</p>
                        <h4>
                          {new Date(acq?.createdDate).toLocaleDateString() ||
                            "N/A"}
                        </h4>
                      </div>
                      <div>
                        <p>Approval Status:</p>
                        <h4>{acq?.approvalStatusEnum || "N/A"}</h4>
                      </div>
                      <div>
                        <p>Applicants:</p>
                        <h4>{acq?.jobListingChannels?.length || 0}</h4>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Basic Information Section */}
                <section
                  style={{
                    backgroundColor: "#F8FBF8",
                    border: "1px solid #D9E9DA",
                    borderRadius: "8px",
                  }}
                  className={DashboardStyle.form_section}
                >
                  <h4 className={DashboardStyle.form_section_title}>
                    Basic <br /> Information
                  </h4>
                  <div className={DashboardStyle.labels_group}>
                    <div>
                      <p>Job Title:</p>
                      <h4>{acq?.jobTitle?.title || "N/A"}</h4>
                    </div>
                    <div>
                      <p>Years of Experience:</p>
                      <h4>{acq?.yearsOfExperience || "N/A"}</h4>
                    </div>
                    <section className="my-2">
                      <div>
                        <p
                          style={{
                            color: "var(--form_title)",
                            fontSize: "0.75rem",
                            lineHeight: "1rem",
                            marginBottom: "0.65rem",
                          }}
                        >
                          Job Responsibility:
                        </p>
                        <ul className="space-y-2">
                          {acq?.jobTitle?.jobResponsibilities?.map((r, idx) => (
                            <li
                              style={{
                                fontSize: "0.875rem",
                                fontWeight: "400",
                                listStyle: "disc",
                              }}
                              key={idx}
                            >{` ${r?.jobDescription || "N/A"}`}</li>
                          )) || "N/A"}
                        </ul>
                      </div>
                    </section>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fill, minmax(32.3%, 1fr))",
                        gap: "10px",
                      }}
                    >
                      <div>
                        <p>Work Mode:</p>
                        <h4>Hybrid</h4>{" "}
                        {/* Placeholder; replace if available */}
                      </div>
                      <div>
                        <p>Opening Date:</p>
                        <h4>
                          {new Date(acq?.openingDate).toLocaleDateString() ||
                            "N/A"}
                        </h4>
                      </div>
                      <div>
                        <p>Closing Date:</p>
                        <h4>
                          {new Date(acq?.closingDate).toLocaleDateString() ||
                            "N/A"}
                        </h4>
                      </div>
                    </div>
                    <div>
                      <p>Qualification:</p>
                      {/* <h4>{qualifications?.qualification || "N/A"}</h4> */}
                      <ul className="space-y-2">
                        {acq?.jobListingQualifications?.map((q, idx) => (
                          <li
                            style={{
                              fontSize: "0.875rem",
                              fontWeight: "400",
                              listStyle: "disc",
                            }}
                            key={idx}
                          >{`${q?.qualification?.qualification || "N/A"}`}</li>
                        ))}{" "}
                      </ul>
                    </div>
                    <div>
                      <p>Skills:</p>
                      {/* <h4>{skills?.name || "N/A"}</h4> */}
                      <ul className="space-y-2">
                        {acq?.jobListingSkills?.map((s, idx) => (
                          <li
                            style={{
                              fontSize: "0.875rem",
                              fontWeight: "400",
                              listStyle: "disc",
                            }}
                            key={idx}
                          >{`${s?.skill?.name || "N/A"}`}</li>
                        ))}{" "}
                      </ul>
                    </div>
                    <div>
                      <p>Channel:</p>
                      <ul className="space-y-2">
                        {acq?.jobListingChannels?.map((c, idx) => (
                          <li
                            style={{
                              fontSize: "0.875rem",
                              fontWeight: "400",
                              listStyle: "disc",
                            }}
                            key={idx}
                          >{`${c?.channel?.channel || "N/A"}`}</li>
                        ))}{" "}
                      </ul>
                    </div>
                  </div>
                </section>
              </FormTemplate>
            </FormProvider>
          </div>
        );
      case "applicants":
        return (
          <div>
            <ApplicantForJobListing data={id} />
          </div>
        );
      case "selected":
        return (
          <div>
            <ApplicantSelected data={id} type={type} />
          </div>
        );
      default:
        return (
          <div>
            <h2 className="text-lg font-semibold">Job Details</h2>
            <p>Default content for the Job Details tab.</p>
          </div>
        );
    }
  };

  return (
    <PageLayout title={"Recruitment Review Details"} hasBack={true}>
      <div className="mb-4">
        <Tabs type={type} />
      </div>
      <div className="p-4 bg-white rounded shadow">{renderContent()}</div>
    </PageLayout>
  );
}

export default RecruitmentReviewGroup;
